module.exports = __webpack_public_path__ + "media/img/favicon-448b4bc2475b4babd9129221f1782c4b.ico";